// AIDEV-NOTE: ESM consumed by the AMD `application` pack via webpack interop (same pattern as
// modules/CapsLockWarning). Uses the global jQuery `$` the pack provides.
// AIDEV-NOTE: PLAT-17716 — three markup generations coexist: legacy `.mainideas` spans (inline
// styles), themed wrappers revealed by a `.display-main-ideas .main-idea` rule in the external S3
// stylesheet, and new-builder `.main-idea` spans styled inline here because a library reading
// without a theme has no wrapper class for the CSS rule to key off.

const THEME_WRAPPERS = '.lower-el-sci, .upper-el-sci, .lower-el-ss, .upper-el-ss, .ms-ss, .hs-ss, .ms-sci';
const SHOW_LABEL = 'Main Ideas';
const HIDE_LABEL = 'Hide Main Ideas';

export function init($mainIdeaButton) {
  $mainIdeaButton.on('click', function(e) {
    e.preventDefault();
    const $legacyMainIdeas = $('.mainideas');
    const $mainIdeaSpans = $('.main-idea');
    const $themedMainIdeas = $(THEME_WRAPPERS);

    // AIDEV-NOTE: PLAT-18017 — replaced an alert(). Keep it, or a click flips `.purple` with
    // nothing to reveal.
    if ($legacyMainIdeas.length === 0 && $mainIdeaSpans.length === 0 && $themedMainIdeas.length === 0) {
      return;
    }

    const showing = !$(this).hasClass('purple');

    if (showing) {
      $legacyMainIdeas.css({ color: '#3434C8', 'font-weight': 'bold' });
      $mainIdeaSpans.css({ color: '#3434C8', 'font-weight': 'bold' });
    }
    else {
      $legacyMainIdeas.css({ color: '#3c3c3c', 'font-weight': 'normal' });
      $mainIdeaSpans.css({ color: '', 'font-weight': '' });
    }
    $themedMainIdeas.toggleClass('display-main-ideas', showing);

    $(this)
      .toggleClass('purple', showing)
      .attr('aria-pressed', String(showing))
      .attr('data-tooltip', showing ? HIDE_LABEL : SHOW_LABEL);
  });
}
